$(document).on 'turbo:load', ->
  $globlnav = $('[data-component="globalnav"]').first()

  unless $globlnav.length < 1
    $(document).ready () =>
      $globlnav.sticky topSpacing: 0, zIndex: 5000
      return

    $(window).on 'resize', _.throttle(((e) =>
      $globlnav.sticky('update')
      return
    ), 250)

  $('body').on 'click', 'a[target="shop"], a[target="_blank"]', () ->
    setTimeout (() => $(this).blur()), 250
